"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDeferred = exports.ForceCancelError = void 0;
var react_1 = require("react");
var state_1 = require("./state");
var ForceCancelError = /** @class */ (function (_super) {
    __extends(ForceCancelError, _super);
    function ForceCancelError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'ForceCancelError';
        _this.isForceCanceled = true;
        return _this;
    }
    return ForceCancelError;
}(Error));
exports.ForceCancelError = ForceCancelError;
exports.default = useDeferred;
function useDeferred(handlers) {
    if (handlers === void 0) { handlers = {}; }
    var _a = react_1.useState(state_1.BEFORE), state = _a[0], setState = _a[1];
    var deferRef = react_1.useRef(null);
    var handlersRef = react_1.useRef(handlers);
    handlersRef.current = handlers;
    var methods = react_1.useMemo(function () { return ({
        execute: function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return deferRef.current ? deferRef.current.promise : methods.forceExecute.apply(methods, args);
        },
        forceExecute: function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            setState(state_1.PENDING);
            if (handlersRef.current.onExecute)
                (_a = handlersRef.current).onExecute.apply(_a, args);
            if (deferRef.current)
                deferRef.current.reject(new ForceCancelError('Canceled by forced execution.'));
            var defer = {};
            defer.promise = new Promise(function (resolve, reject) {
                defer.resolve = resolve;
                defer.reject = reject;
            });
            return (deferRef.current = defer).promise;
        },
        resolve: function (value) {
            if (!deferRef.current)
                return;
            setState(state_1.RESOLVED);
            if (handlersRef.current.onResolve)
                handlersRef.current.onResolve(value);
            if (handlersRef.current.onComplete)
                handlersRef.current.onComplete();
            deferRef.current.resolve(value);
            deferRef.current = null;
        },
        reject: function (reason) {
            if (!deferRef.current)
                return;
            setState(state_1.REJECTED);
            if (handlersRef.current.onReject)
                handlersRef.current.onReject(reason);
            if (handlersRef.current.onComplete)
                handlersRef.current.onComplete();
            deferRef.current.reject(reason);
            deferRef.current = null;
        }
    }); }, []);
    return __assign({ state: state, isBefore: state === state_1.BEFORE, isPending: state === state_1.PENDING, isResolved: state === state_1.RESOLVED, isRejected: state === state_1.REJECTED, isComplete: state === state_1.RESOLVED || state === state_1.REJECTED }, methods);
}
exports.useDeferred = useDeferred;
